import { Row, Card } from 'antd'

import CourtsideStyle from '../../styles/InsuranceCourtsideClub.module.css'

const InsuranceCourtsideClub = () => {
  return (
    <div className={`${CourtsideStyle["insurance-courtside-club-screen"]}`}>
      <Row justify="center">
        <Card className={`${CourtsideStyle["insurance-courtside-club-card"]}`}>
          <article>
            <h2 className={`${CourtsideStyle["insurance-courtside-club-above-title"]}`}>
              <a
                className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`}
                href="https://www.detroitnews.com/"
                rel="noreferrer"
                target="_blank"
              >
                The Detroit News
              </a>
            </h2>
            <p>
              <a
                className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`}
                href="https://www.detroitnews.com/business/"
                rel="noreferrer"
                target="_blank"
              >
                BUSINESS
              </a>
            </p>

            <hr />

            <h1 className={`${CourtsideStyle["insurance-courtside-club-title"]}`}>
              Pistons unveil plans for courtside club at Little Caesars Arena
            </h1>

            <p className={`${CourtsideStyle["insurance-courtside-club-author-name"]}`}>
              <a
                className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`}
                href="https://www.detroitnews.com/staff/7583228002/alex-harring/"
                rel="noreferrer"
                target="_blank"
              >
                Alex Harring
              </a>{' '}
              The Detroit News
            </p>
            <p>Published 1:22 p.m. ET July 18, 2021</p>
            <hr />

            <p>
              What&apos;s being billed as a first-of-its-kind courtside club with a bar that offers select liquors, a
              house beer and an appetizer-style menu will be a new fixture at Detroit Pistons games.
            </p>
            <p>
              The CURE Insurance Courtside Club will be behind a basketball hoop near the visitors&apos; bench.
              Renderings of the club show high-top tables with no chairs.
            </p>
            <p>
              The club will be open to people with courtside seats, which are some of the most expensive game tickets.
              It will also be open during Pistons networking and brand-partner events.
            </p>
            <p>
              “The CURE Insurance Courtside Club is a unique opportunity to reshape and enhance the fan experience,”
              said Brenden Mallette, senior vice president of corporate partnerships and engagement for the Pistons, in
              a news release. “As our fans return to Little Caesars Arena this fall in full force for the first time in
              nearly 18 months, the club is one of many new amenities that will welcome them back to Detroit
              Basketball.”
            </p>
            <p>
              The club will first open for the 2021-2022 pre-season home opener. Being part of the courtside club comes
              with parking in a garage attached to Little Caesars Arena, where the Pistons play home games.
            </p>
            <p>
              <a className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`} href="mailto:AHarring@detroitnews.com">
                AHarring@detroitnews.com
              </a>
            </p>
            <p>
              <a
                className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`}
                href="https://twitter.com/alex_harring"
                rel="noreferrer"
                target="_blank"
              >
                Twitter: @alex_harring
              </a>
            </p>

            <hr />
            <p className={`${CourtsideStyle["insurance-courtside-club-foot-note"]}`}>
              <a
                className={`${CourtsideStyle["insurance-courtside-club-hyperlinks"]}`}
                href="https://www.detroitnews.com/story/business/2021/07/18/pistons-unveil-plans-courtside-club-little-caesars-arena/8007569002/"
                rel="noreferrer"
                target="_blank"
              >
                https://www.detroitnews.com/story/business/2021/07/18/pistons-unveil-plans-courtside-club-little-caesars-arena/8007569002/
              </a>
            </p>
          </article>
        </Card>
      </Row>
    </div>
  )
}

InsuranceCourtsideClub.propTypes = {}

export default InsuranceCourtsideClub
